import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class PassportVerifiedGuard implements CanActivate {
  constructor(
    private msalService: MsalService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const activeAccount = this.msalService.instance.getActiveAccount();

    const t = activeAccount?.idTokenClaims
    console.log("claims in passport guard",t)


    if (t?.['extension_CrmPassportVerified'] === true) {
      return true;
    }

    // If passport is not verified, redirect to verify-passport page
    await this.router.navigate(['/verify-passport']);
    return false;
  }
}
